// extracted by mini-css-extract-plugin
export default {"msg":"ErrorMsg_msg__XUdnW"};